import { LIVE_TEMPLATES } from '../data/videoTemplates';
import { Modal } from '../components/Modal';
import { TemplateCard } from '../components/TemplateCard';
import './PickerPopups.css';

// "Change scene" during the pick step: only templates that can actually generate.
export function TemplatePickerPopup({ isOpen, onClose, selectedId, onSelect }) {
    return (
        <Modal isOpen={isOpen} onClose={onClose} size="lg" title="Change scene" subtitle={`${LIVE_TEMPLATES.length} scenes ready to generate`}>
            <div className="pickGrid">
                {LIVE_TEMPLATES.map((t, i) => (
                    <TemplateCard
                        key={t.id}
                        template={t}
                        order={i}
                        compact
                        selected={t.id === selectedId}
                        onOpen={(tpl) => { onSelect(tpl); onClose(); }}
                    />
                ))}
            </div>
        </Modal>
    );
}
